import { DateRangePickerWithPresets } from '@heidi/design-system/date-range-picker';
import {
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@heidi/design-system/dropdown-menu';
import { TypographyCaption, TypographyP2 } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { CalendarIcon, ChevronRight } from 'lucide-react';
import { useIntl } from 'react-intl';
import { formatSessionDateRange } from '../../../../session-list/format-date-range';
import { useDateFilter } from './hooks/useDateFilter';

export const DateFilter = () => {
  const intl = useIntl();
  const { t } = useTranslations();
  const { isOpen, setIsOpen, selectedDateRangeFilter, setSelectedDateRangeFilter } =
    useDateFilter();

  return (
    <DropdownMenuGroup>
      <DropdownMenuSub open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuSubTrigger
          hideChevron
          className="flex items-center justify-between gap-2 py-1.5 pl-2.5 pr-1.5"
        >
          <div className="flex items-center gap-2">
            <CalendarIcon size={16} className="min-w-4" />
            <div className="flex flex-col justify-center gap-0.5">
              <TypographyP2>{t('common.date')}</TypographyP2>
              {selectedDateRangeFilter.from && selectedDateRangeFilter.to && (
                <TypographyCaption className="text-text-secondary">
                  {formatSessionDateRange(
                    intl,
                    selectedDateRangeFilter.from,
                    selectedDateRangeFilter.to
                  )}
                </TypographyCaption>
              )}
            </div>
          </div>
          <ChevronRight
            size={16}
            className="min-w-4 text-text-secondary rtl:-scale-x-100"
          />
        </DropdownMenuSubTrigger>
        <DropdownMenuPortal>
          <DropdownMenuSubContent className="p-0" sideOffset={4}>
            <DateRangePickerWithPresets
              range={selectedDateRangeFilter}
              setRange={setSelectedDateRangeFilter}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
            />
          </DropdownMenuSubContent>
        </DropdownMenuPortal>
      </DropdownMenuSub>
    </DropdownMenuGroup>
  );
};
